import axios from "axios";
export default {
    getVersionInfo: () => axios.post("/About/GetVersionInfo", {})
};
